export default __webpack_public_path__ + "static/media/img-slider-token-1.07e57cee.png";